export default __webpack_public_path__ + "static/media/1.02128f34.jfif";